class Extranet.Models.ValueAddModel extends Backbone.Model
  idAttribute: 'uuid'
